export const CONFIG = {
  // ── Life defaults ──────────────────────────────────────────────────────────
  DEFAULT_LIFESPAN: 80,
  WEEKS_PER_YEAR:   52,

  // ── Constraint thresholds ─────────────────────────────────────────────────
  // Cognitive score (Low=1 Med=2 High=3) threshold per active cap
  COGNITIVE_WEIGHTS:     { 1: 1, 2: 2, 3: 3 },
  COGNITIVE_THRESHOLDS:  { 3: 7, 4: 9, 5: 11 },

  // Time load ratios
  TIME_WARN_RATIO:  0.85,
  TIME_BLOCK_RATIO: 1.00,
  SINGLE_GOAL_CAP:  0.70,   // one goal consuming >70% → flag

  // Duration compression
  COMPRESS_FACTOR: 0.50,

  // ── Weekly review ─────────────────────────────────────────────────────────
  REVIEW_CYCLE_DAYS:     7,
  CONSISTENCY_TARGET:    0.80,
  MIN_REVIEWS_FOR_TREND: 3,

  // ── Inactivity ────────────────────────────────────────────────────────────
  INACTIVITY_DAYS: 14,

  // ── Feature unlock triggers ───────────────────────────────────────────────
  UNLOCK: {
    TASK_PHASE_WEEKS:       4,
    TASK_HIGH_EFFORT_WEEKS: 2,
    BASIC_ANALYSIS_DAYS:    14,
    FULL_ANALYSIS_DAYS:     30,
    COST_GOAL_COUNT:        5,
    DEPS_GOAL_COUNT:        5,
    DRIFT_DAYS:             30,
  },

  // ── Goal palette ──────────────────────────────────────────────────────────
  GOAL_COLORS: [
    '#a8ff3e', '#38bdf8', '#fb923c', '#c084fc',
    '#34d399', '#f472b6', '#facc15', '#60a5fa',
  ],

  // ── Onboarding life audit domains ────────────────────────────────────────
  AUDIT_DOMAINS: ['Career', 'Health', 'Relationships', 'Finances', 'Personal Growth'],

  // ── Goal status machine ───────────────────────────────────────────────────
  GOAL_STATUSES: ['aspirational', 'committed', 'active', 'paused', 'completed', 'archived'],
  BUCKETS:       ['aspirational', 'committed'],

  // ── Effort labels ─────────────────────────────────────────────────────────
  EFFORT: { 1: 'Low', 2: 'Medium', 3: 'High' },
}

export default CONFIG
